import React, { FC } from 'react';
import { HorizontalSlider } from '@components/atoms/HorizontalSlider';
import { ProductCategoryCard } from '@components/molecules/ProductCategoryCard';
import { SITE_URLS } from '@constants';

export interface CategoriesHorizontalSliderProps {
    categories: {
        uuid?: string;
        name?: string;
        image?: string;
        active?: boolean;
    }[];
}

export const CategoriesHorizontalSlider: FC<CategoriesHorizontalSliderProps> = ({ categories }) => {
    return (
        <HorizontalSlider
            breakpointsStyles={{
                xs: { height: '10.375em', itemsGap: '14px', itemsWidth: '6.25em' },
                md: { height: '12.625em', itemsGap: '25px', itemsWidth: '7.875em' },
                xxl: { itemsGap: '32px' },
            }}>
            {categories.map((category, index) => (
                <ProductCategoryCard
                    key={`category-${index}`}
                    {...category}
                    href={`${SITE_URLS.productsSubcategory.replace(':categoryUuid', `${category.uuid}`)}`}
                />
            ))}
        </HorizontalSlider>
    );
};
